import { useCookie, useRoute } from '#imports'

/**
 * Returns the persisted utm_source value for the current session.
 * The value is captured from the URL on first visit and stored in a session cookie.
 *
 * @returns The utm_source value or null if not set
 */
export function useUtmSource(route = useRoute()) {
  if (typeof route.query.utm_source === 'string') return route.query.utm_source

  return useCookie('utm_source', {
    maxAge: undefined,
  })?.value
}
